import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BaseDialogComponent} from '@q9elements/ui-kit/common';

import {GridView} from '../../models/interfaces';
import {GridViewsDaoService} from '../../services/grid-views-dao.service';

@Component({
  selector: 'q9ma-delete-grid-view-dialog',
  templateUrl: './delete-view-dialog.component.html',
  styleUrls: ['./delete-view-dialog.component.scss']
})
export class DeleteViewDialogComponent extends BaseDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public view: GridView,
    private gridViewsDaoService: GridViewsDaoService,
    protected override dialogRef: MatDialogRef<BaseDialogComponent>
  ) {
    super();
  }

  protected override sendSubmitRequest() {
    return this.gridViewsDaoService.delete(this.view.id);
  }
}
